// extracted by mini-css-extract-plugin
module.exports = {"container":"bT","copyContainer":"cT","hidden":"dT"};